module.exports = __webpack_public_path__ + "static/img/2270_phase_function_Paper_Points.3f90cb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2270_phase_function_Paper_Points.png
// module id = rWbV
// module chunks = 0